

export const RoutesConstants = {
    HOME: '/',
    SIP_CALCULATOR: '/sip-calculator',
    UNKNOWN: '/*'
    // Add more routes here as needed
};
